import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description The operation is idempotent and preserves the first viewed timestamp.
Repeated requests return 204. A previously fetched communication may still be marked
after expiry, deactivation, removal from the audience or archival.
Edits and reactivation of the same id do not reset this manager's viewed state.

 * @tags Communications
 * @summary Mark a communication as viewed on CTA click or explicit close
 */
export const MarkCommunicationAsViewedContentType = '' as const;
export type MarkCommunicationAsViewedRequest = void;
export type MarkCommunicationAsViewedResponses = LinkCommonErrorResponses & {
    /**
     * @description Communication does not exist in the current store
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type MarkCommunicationAsViewedResponseSuccess = undefined;
export type MarkCommunicationAsViewedSearchParams = undefined;
export type MarkCommunicationAsViewedPathParameters = {
    id: string;
};
export const MarkCommunicationAsViewedUrl = '/communications/{id}/viewed' as const;
export const MarkCommunicationAsViewedMethod = 'POST' as const;
export const getMarkCommunicationAsViewedUrl = (params: MarkCommunicationAsViewedPathParameters) =>
    MarkCommunicationAsViewedUrl.replace(/\{(\w+)\}/g, (_match, param: keyof MarkCommunicationAsViewedPathParameters) =>
        String(params[param])
    );
